import {Component, forwardRef, Input, OnInit, EventEmitter, Output} from '@angular/core';
import {NG_VALUE_ACCESSOR, NG_VALIDATORS} from '@angular/forms';
import {InputFieldComponent} from '../input-field/input-field.component';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'resident-email-field',
    templateUrl: 'resident-email-field.template.html',
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => ResidentEmailFieldComponent), multi: true},
        {provide: NG_VALIDATORS, useExisting: forwardRef(() => ResidentEmailFieldComponent), multi: true}
    ],
    styleUrls: ['resident-email-field.style.scss']
})
export class ResidentEmailFieldComponent extends InputFieldComponent implements OnInit {
    @Input() invalidEmail = false;
    @Input() canDeleteEmail = false;
    @Input() canSetAsValid = false;
    @Output() setAsValid: EventEmitter<any> = new EventEmitter<any>();
    @Output('deleteEmail') deleteEmail: EventEmitter<any> = new EventEmitter<any>();
    hintActive: boolean = false;

    constructor() {
        super();
    }

    ngOnInit() {
        super.ngOnInit();
        this.icon += this.invalidEmail ? ' invalid' : '';
    }

    delete() {
        this.deleteEmail.emit(this.value);
    }
    get iconTitle() {
        if (!this.invalidEmail) {
            return ''
        }
        if (this.canSetAsValid) {
            return 'Mark email as valid.';
        }
        return 'Invalid email';
    }

    public SetValidEmail() {
        if (this.invalidEmail && this.canSetAsValid) {
            this.setAsValid.emit();
        }
    }

    public apply(field): void {
        if (!this.editOnly && $(field).hasClass('ng-valid')) {
            this.editModeOff();
            this.update.emit();
            this.copyValue();
        }
    }

    public validator(value): boolean {
        return true;
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/fields/resident-email-field/resident-email-field.component.ts